import { Injectable } from '@angular/core';

import { AbstractAppConfigService } from '@abstract-services/app-config/1.0/app-config.abstract-service';
import { AppConfig } from '@interfaces/app-config/1.0';
import * as ConfigJson from 'config/config';

@Injectable({ providedIn: 'root' })
export class AppConfigService implements AbstractAppConfigService {
  static settings: AppConfig;

  get settings() {
    return AppConfigService.settings;
  }

  load() {
    return new Promise<void>((resolve, reject) => {
      AppConfigService.settings = ConfigJson.default as AppConfig;
      resolve();
    });
  }

  isEnabled(featureName: string) {
    // Read the value from the config service
    if (AppConfigService.settings.hasOwnProperty(featureName)) {
      return AppConfigService.settings[featureName].enabled;
    }
    return false; // if feature not found, default to turned off
  }
}
